import React, { useEffect, useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import Box from '@material-ui/core/Box';
import {
    Initiate as DEMAT_TRANSECATION,
    Select as SELECT_ACTIVATION
} from 'Components/Api/DematAPI';
import { SelectRedirectUrlByName as DEMAT_LOGIN } from 'Components/Api/RedirectUrlAPI';
import { IsPaymentDueForService } from 'Components/Api/ServiceSubscriptionChargeAPI';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import {
    Container,
    Grid,
    Paper,
    CircularProgress,
    Button
} from '@material-ui/core';
import { useHistory } from 'react-router';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import { PLEASE_PROVIDE_VALID, DEMAT } from 'Components/Helper/Messages';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import HOCLoader from 'Components/Loader/HOCLoader';
import ReactTable from 'Components/ReactTable/ReactTable';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import OfferIcon from 'Components/SvgButtons/OfferIcon';
import { SubscriptionRenew } from 'Pages/InnerPages/ServiceSubscriptionCharge/SubscriptionRenew';

const CustomContainer = HOCLoader(Container);

export const Demat = () => {
    const formRef = useRef();
    const history = useHistory();
    const [itemList, setItemList] = useState([]);
    const classes = commonStyle();
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [mainColumns, setMainColumns] = useState([]);
    const [isRenewAlertOpen, setIsRenewAlertOpen] = useState(false);
    const [isExpairAlertOpen, setIsExpairAlertOpen] = useState(false);
    const [requestObj, setRequestObj] = useState(DEMAT);

    const [renewMessage, setRenewMessage] = useState('');

    const [formObj, setFormObj] = useState({
        ServiceID: DEMAT,
        PersonName: '',
        MobileNumber: '',
        EmailID: '',
        PanNumber: ''
    });

    const validationSchema = Yup.object({
        PersonName: Yup.string().required(PLEASE_PROVIDE_VALID + 'Name'),
        EmailID: Yup.string().required(PLEASE_PROVIDE_VALID + 'address'),
        MobileNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number'),
        PanNumber: Yup.string()
            .length(10, 'Must be 10 alpha numeric')
            .required(PLEASE_PROVIDE_VALID + ' pan number')
    });
    const submitHandle = async (values, { resetForm }) => {
        if (loadingOpen) return;
        setIsAlertOpen(true);
        setConfirmAlertRequest(values);
    };

    const DematRegistration = async (values) => {
        setLoadingOpen(true);
        var request = JSON.stringify(values);

        setIsError(false);

        var response = await DEMAT_TRANSECATION(request);
        setLoadingOpen(false);
        setResponseMessage(response.data);
        setIsError(true);

        setSeverity('success');
        if (!response.status) {
            setSeverity('error');
            return;
        }
        let data = JSON.parse(response.data);
        setFormObj({
            PersonName: '',
            MobileNumber: '',
            EmailID: '',
            PanNumber: ''
        });
        let param = {
            RedirectURL: data.URL
        };

        history.push('/DematRedirectURL', param);
        return;
    };

    const DematLogin = async () => {
        var requestObj = { ServiceID: DEMAT };
        setLoadingOpen(true);
        var request = JSON.stringify(requestObj);

        setIsError(false);

        var response = await IsPaymentDueForService(request);
        setLoadingOpen(false);

        setIsError(true);

        setSeverity('success');
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        let data = JSON.parse(response.data);
        setRenewMessage(data.Message);
        if (data.IsPaymentOverDue === true) {
            setSeverity('error');
            setIsExpairAlertOpen(true);
            return;
        }
        if (data.Days <= 10) {
            setIsRenewAlertOpen(true);
            return;
        }
        DematLoginURL();
    };

    const DematLoginURL = async () => {
        var requestObj = { Name: 'Demat' };
        setLoadingOpen(true);
        var request = JSON.stringify(requestObj);

        setIsError(false);

        var response = await DEMAT_LOGIN(request);
        setLoadingOpen(false);

        setIsError(true);

        setSeverity('success');
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }
        let data = JSON.parse(response.data);

        let param = {
            RedirectURL: data.Url
        };

        history.push('/DematLoginRedirect', param);
        return;
    };

    const selectData = async () => {
        var requestObj = {
            ServiceID: DEMAT,
            ToDate: new Date(),
            FromDate: new Date().addDays(-7),
            Status: 'ALL',
            TakeCount: 10
        };
        var request = JSON.stringify(requestObj);

        const response = await SELECT_ACTIVATION(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        var data = JSON.parse(response.data);
        setItemList(data.list);
    };

    useEffect(() => {
        createColumns();
        selectData();
    }, []);
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'TransactionMasterID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'User',
            name: 'FirmName'
        });

        columns.push({
            label: 'RequestID',
            name: 'RequestID'
        });
        columns.push({
            label: 'Person Name',
            name: 'PersonName'
        });
        columns.push({
            label: 'Mobile Number',
            name: 'MobileNumber'
        });
        columns.push({
            label: 'EmailID',
            name: 'EmailID'
        });
        columns.push({
            label: 'Pan Number',
            name: 'PanNumber'
        });
        columns.push({
            label: 'UCC',
            name: 'UCC'
        });

        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });
        columns.push({
            label: 'Op.Bal',
            name: 'OpeningBalance'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount'
        });
        columns.push({
            label: 'Comm',
            name: 'RetailerComm'
        });
        columns.push({
            label: 'Cl.Bal',
            name: 'ClosingBalance'
        });

        setMainColumns(columns);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={submitHandle}
                resetForm={formObj}
            >
                {({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <h2 className={classes.PaperHead_h2}>
                                        Demat Activation Request
                                        <span className={classes.Require}>
                                            *
                                        </span>
                                    </h2>
                                </Grid>

                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={6}
                                    lg={6}
                                    style={{
                                        display: 'flex',
                                        direction: 'rtl'
                                    }}
                                >
                                    <h2 className={classes.PaperHead_h2}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            onClick={() => {
                                                DematLogin();
                                            }}
                                        >
                                            Daily Login
                                        </Button>
                                    </h2>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="PersonName"
                                                name="PersonName"
                                                placeholder="PersonName"
                                                title="PersonName"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="EmailID"
                                                name="EmailID"
                                                placeholder="EmailID"
                                                title="EmailID"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="MobileNumber"
                                                name="MobileNumber"
                                                icon="mobile"
                                                placeholder="MobileNumber"
                                                title="MobileNumber"
                                                length="10"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="PanNumber"
                                                name="PanNumber"
                                                length="10"
                                                placeholder="PanNumber"
                                                title="PanNumber"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Request"
                                                endIcon={<OfferIcon />}
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loadingOpen}
                                            >
                                                Request
                                            </PrimaryButton>
                                            {loadingOpen && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <SecondaryButton
                                                type="reset"
                                                title="Reset"
                                                endIcon={<ResetIcon />}
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </SecondaryButton>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div
                                        className={classes.SubmitWrapper}
                                    ></div>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            <ReactTable data={itemList} columns={mainColumns} />

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="Demat Request"
                    message="Are you sure to do demat request?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        DematRegistration(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            {isRenewAlertOpen ? (
                <SubscriptionRenew
                    isOpen={isRenewAlertOpen}
                    title="Renew Subscription"
                    error={renewMessage}
                    submitCallback={(value) => {
                        setIsRenewAlertOpen(value);
                    }}
                    resendCallback={(value) => {}}
                    onDismissCallback={(value) => {
                        setIsRenewAlertOpen(value);
                        DematLoginURL();
                    }}
                    requestObj={requestObj}
                />
            ) : null}

            {isExpairAlertOpen ? (
                <SubscriptionRenew
                    isOpen={isExpairAlertOpen}
                    title="Expir Subscription"
                    error={renewMessage}
                    submitCallback={(value) => {
                        setIsExpairAlertOpen(value);
                    }}
                    resendCallback={(value) => {}}
                    onDismissCallback={(value) => {
                        setIsExpairAlertOpen(value);
                    }}
                    requestObj={requestObj}
                />
            ) : null}
        </CustomContainer>
    );
};
